import React from 'react';
import { useSelector } from 'react-redux';
import { useResponsive } from '../../hooks/use_responsive';
import {
  catalogPageRegex,
  productDetailPageRegex,
  waterbodyBoatRampsRegex,
  waterbodyCurrentConditionsRegex,
  waterbodyFishingPatternsRegex,
  waterbodyFishingReportsRegex,
} from '../../lib/urls';
import { getPath } from '../../redux/router';
import { RoutePaths } from '../../routes';
import { BannerCatalog } from './banner_catalog';
import { BannerMap } from './banner_map';
import { BannerPdp } from './banner_pdp';
import { BannerWaterbodyBoatRamps } from './banner_waterbody_boat_ramps';
import { BannerWaterbodyCurrentConditions } from './banner_waterbody_current_conditions';
import { BannerWaterbodyFishingPatterns } from './banner_waterbody_fishing_patterns';
import { BannerWaterbodyFishingReports } from './banner_waterbody_fishing_reports';

const getWaterbodySlug = (pathname: string) => {
  const match = pathname.match(new RegExp(`^${RoutePaths.WATERS}/([^/]+)/`));
  return match ? match[1] : null;
};

export const BannerManager = () => {
  const { isDesktop } = useResponsive();
  const pathname = useSelector(getPath);
  const isWaterbodyFishingReportsPage = waterbodyFishingReportsRegex.test(pathname);
  const isWaterbodyFishingPatternsPage = waterbodyFishingPatternsRegex.test(pathname);
  const isWaterbodyCurrentConditionsPage = waterbodyCurrentConditionsRegex.test(pathname);
  const isWaterbodyBoatRampsPage = waterbodyBoatRampsRegex.test(pathname);
  const waterbodySlug = getWaterbodySlug(pathname);
  const isMapPage = pathname === RoutePaths.MAP;
  const isPdpPage = productDetailPageRegex.test(pathname);
  const isCatalogPage = catalogPageRegex.test(pathname);

  if (isDesktop) {
    return null;
  }

  if (isWaterbodyFishingReportsPage) {
    return <BannerWaterbodyFishingReports urlSlug={waterbodySlug} />;
  }

  if (isWaterbodyFishingPatternsPage) {
    return <BannerWaterbodyFishingPatterns urlSlug={waterbodySlug} />;
  }

  if (isWaterbodyCurrentConditionsPage) {
    return <BannerWaterbodyCurrentConditions urlSlug={waterbodySlug} />;
  }

  if (isWaterbodyBoatRampsPage) {
    return <BannerWaterbodyBoatRamps urlSlug={waterbodySlug} />;
  }
  if (isMapPage) {
    return <BannerMap />;
  }

  if (isPdpPage) {
    return <BannerPdp />;
  }

  if (isCatalogPage) {
    return <BannerCatalog />;
  }
  return null;
};
